import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';
import { SectionHeading } from '../shared/SectionHeading';
import { StageIcon } from './StageIcon';

const journeyDuration = 9;

const invoiceStages = [
  { icon: 'erp', key: 'erp' },
  { icon: 'invoice', key: 'invoice' },
  { icon: 'validation', key: 'validation' },
  { icon: 'format', key: 'format' },
  { icon: 'authority', key: 'authority' }
];

export const InvoiceJourney = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.invoiceJourney} id='how-it-works'>
      <div className={styles.wideShell}>
        <SectionHeading
          eyebrow={t('homepage.invoiceJourney.eyebrow')}
          title={t('homepage.invoiceJourney.title')}
          description={t('homepage.invoiceJourney.description')}
        />
        <div className={styles.pipelineWrap}>
          <div className={styles.pipelineTrack} aria-hidden='true'>
            <svg className={styles.pipelineLine} viewBox='0 0 1240 56' preserveAspectRatio='none'>
              <path d='M30 44H1210' />
              <path d='M30 44H1210' />
            </svg>
            <div className={styles.pipelineInvoice}>
              <svg viewBox='0 0 26 32'>
                <path d='M3 2h13l7 7v19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' />
                <path d='M16 2v7h7' />
                <path d='M7.5 15h11M7.5 19.5h11M7.5 24H14' />
              </svg>
            </div>
          </div>
          <div className={styles.pipeline}>
            {invoiceStages.map((stage, index) => (
              <article
                className={styles.pipelineStage}
                key={stage.key}
                style={
                  {
                    '--stage-delay': `${(index * journeyDuration) / invoiceStages.length}s`
                  } as CSSProperties
                }
              >
                <StageIcon type={stage.icon} />
                <h3>{t(`homepage.invoiceJourney.stages.${stage.key}.title`)}</h3>
                <p>{t(`homepage.invoiceJourney.stages.${stage.key}.description`)}</p>
              </article>
            ))}
          </div>
        </div>
        <p className={styles.pipelineNote}>{t('homepage.invoiceJourney.note')}</p>
      </div>
    </section>
  );
};
